import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { products } from "../../../../../redux/products/action";
import { selectProductsListItems } from "../../../../../redux/products/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";

const ManagementProducts = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectProductsListItems)
    const [pageSize, setPageSize] = useState(10);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true},
          { field: 'Price', headerName: 'Price', filter: true, sortable: true },
          { field: 'IsAvailable', headerName: 'Available',cellRenderer: 'yesNoRenderer' },
          { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOn' ,isDateValueFormat:true},
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const fetchProducts=()=>{
        dispatch(products.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`,entity:'products',jsonData:{
         "PageNumber": pageData,
         "PageSize": pageSize,
         "SortField": "Id",
         "SortOrder": "desc",
         
     
         }}))
       }
       const handleDelete=(data: any)=>{
        dispatch(products.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/delete`,
          entity: 'products',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(products.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`,entity:'products',jsonData:{
           "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          name: 'Add Product',
          callback: () => handleAdd(),
        }
      ];
	useEffect(() => {
        createColumnDefs()
        fetchProducts()
	}, [pageData,pageSize])

	return (
  <>
      {itemsData?.isLoading ? <PageLoader />
 : 
  	<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Products" />
      }
    </>
	
       
     
	);
};

export default ManagementProducts;


